<!-- eslint-disable -->
<template>
  <component
    v-if="isExternalLink(to)"
    is="a"
    :href="to"
    target="_blank"
    rel="noopener"
  >
    <slot />
  </component>

  <router-link v-else :to="to">
    <slot />
  </router-link>
</template>

<script>
/* eslint-disable */
import { isExternal } from '@/utils/validate';

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  methods: {
    isExternalLink(routePath) {
      return isExternal(routePath);
    },
    linkProps(url) {
      if (this.isExternalLink(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener',
        };
      }
      return {
        is: 'router-link',
        to: url,
      };
    },
  },
};
</script>
